import { render, staticRenderFns } from "./TabelaDeAprovarContasAPagar.vue?vue&type=template&id=3dde123d&scoped=true"
import script from "./TabelaDeAprovarContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeAprovarContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeAprovarContasAPagar.vue?vue&type=style&index=0&id=3dde123d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde123d",
  null
  
)

export default component.exports